module.exports = __webpack_public_path__ + "img/oeillet_de_nice.02e172a5.jpg";